import { FC } from 'react';
import Image, { ImageLoader } from 'next/image';
import ImageLegacy from 'next/legacy/image';

import * as U from './ImageProxy.utils';
import * as T from './ImageProxy.types';

export const ImageProxy: FC<T.ImageProxyProps> = ({
  width,
  height,
  resizingType = 'fit',
  extension = 'webp',
  gravityType = 'no',
  sourceWidth,
  sourceHeight,
  legacy,
  ...props
}) => {
  // лоадер для формирования ссылки до изображения через imgproxy
  // https://github.com/imgproxy/imgproxy/blob/master/docs/generating_the_url.md
  const loader: ImageLoader = ({ src, quality }) => {
    const imgWidth = (width || sourceWidth || 300) as number;
    const imgHeight = (height || sourceHeight || 300) as number;
    const imgQuality = quality || 0;
    const enlarge = 0;

    return U.buildImgProxyUrl(
      resizingType,
      imgWidth,
      imgHeight,
      enlarge,
      gravityType,
      imgQuality,
      src,
      extension
    );
  };

  return legacy ? (
    <ImageLegacy loader={loader} {...props} />
  ) : (
    <Image loader={loader} width={width} height={height} {...props} />
  );
};
